<template>
  <div v-bind:class="{ 'op--modal-container':true, hide: !notification.showForm }" @click="closeNotifForm">
    <div class="op--modal">
      <div class="op--modal-content">
        <div @click.stop class="notification-form">
          <div class="heading">{{ $t('consumer.list.pushNotif') }}</div>
          <div class="nf-content" @click="closeEmoji">
            <div v-show="!notification.errorMsg && !notification.success">
              <div :class="{'data-field':true, 'has-error':!!notification.targetMessage, 'reduce-margin':notification.target === 'geofence'}"
                v-if="!hideTargetOption">
                <div class="label">{{ $t('consumer.list.target') }}:</div>
                <select v-model="notification.target" @change="targetUpdate" :disabled="notification.geofence.loading">
                  <option value="all" v-if="!removeAllActiveUserOption">All Active User</option>
                  <option value="selected">{{ $t('consumer.list.selectedUser') }}</option>
                  <option value="geofence" v-if="showGeofenceOption">Geofence</option>
                  <option value="sector" v-if="showBySector">By Sector Group</option>
                </select>
                <span class="error-msg">{{ notification.targetMessage }}</span>
              </div>

              <div :class="{'data-field':true, 'has-error':!!notification.geofence.error.type, 'reduce-margin':notification.target === 'geofence'}"
                v-if="notification.geofence.show">
                <div class="label">Geofence Type:</div>
                <select v-model="notification.geofence.type" @change="updateGeofenceList" :disabled="notification.geofence.loading">
                  <option value="airport">Airport</option>
                  <option value="staging">Staging</option>
                  <option value="serviceArea">Service Area</option>
                </select>
                <span class="error-msg">{{ notification.geofence.error.type }}</span>
              </div>

              <div :class="{'data-field':true, 'has-error':!!notification.geofence.error.brand, 'reduce-margin':notification.target === 'geofence'}"
                v-if="notification.geofence.show && notification.geofence.type === 'serviceArea'">
                <div class="label">Brand:</div>
                <select v-model="notification.geofence.brand" @change="updateGeofenceList" :disabled="notification.geofence.loading">
                  <option v-for="brand in brands" :key="brand.id" :value="brand.id">{{brand.name}}</option>
                </select>
                <span class="error-msg">{{ notification.geofence.error.brand }}</span>
              </div>

              <div :class="{'data-field':true, 'has-error':!!notification.geofence.error.id}"
                v-if="notification.geofence.show && ((notification.geofence.type === 'serviceArea' && notification.geofence.brand) || (notification.geofence.type && notification.geofence.type !== 'serviceArea'))">
                <div class="label">Geofence:</div>
                <div class="select-box">
                  <div class="select-loader" v-if="notification.geofence.loading">
                    <i class="fas fa-spinner fa-spin"></i>
                    Loading...
                  </div>
                  <select v-model="notification.geofence.id" :disabled="notification.geofence.loading">
                    <option v-for="geofence in notification.geofence.list" :key="geofence.id" :value="geofence.id">{{geofence.name}}</option>
                  </select>
                </div>
                <span class="error-msg">{{ notification.geofence.error.id }}</span>
              </div>

              <div :class="['data-field', {'has-error':!!notification.sectorError, 'reduce-margin':true}]"
                v-if="notification.target === 'sector'">
                <div class="label">Sector:</div>
                <select v-model="notification.sector" :disabled="notification.geofence.loading">
                  <option value="group1" class="group1">Group 1 </option>
                  <option disabled class="disabled-opt _group1">&nbsp;&nbsp;&nbsp;Santa Monica / Marina, West LA / West Hollywood</option>
                  <option disabled class="disabled-opt _group1">&nbsp;&nbsp;&nbsp;Mid-Wilshire / Hollywood, Downtown Area</option>
                  <option disabled class="disabled-opt _group1">&nbsp;&nbsp;&nbsp;South Bay / Palos Verdes, South Central</option>
                  <option value="group2">Group 2</option>
                  <option disabled class="disabled-opt">&nbsp;&nbsp;&nbsp;Downey / Brea, San Pedro / LA Harbor</option>
                  <option disabled class="disabled-opt">&nbsp;&nbsp;&nbsp;Long Beach Shore, Anaheim / Disney</option>
                  <option disabled class="disabled-opt">&nbsp;&nbsp;&nbsp;Orange County Beach Cities</option>
                  <option value="group3">Group 3</option>
                  <option disabled class="disabled-opt">&nbsp;&nbsp;&nbsp;Long West Valley, Short West Valley</option>
                  <option disabled class="disabled-opt">&nbsp;&nbsp;&nbsp;North Valley, East Valley, Mid-Valley</option>
                  <option disabled class="disabled-opt">&nbsp;&nbsp;&nbsp;Glendale / La Canada, Pasadena / North San Gabriel Valley</option>
                  <option value="group4">Group 4</option>
                  <option disabled class="disabled-opt">&nbsp;&nbsp;&nbsp;West Covina / Ontario, Diamond Bar</option>
                  <option disabled class="disabled-opt">&nbsp;&nbsp;&nbsp; Riverside / Corona, Palm Springs, San Diego</option>
                </select>
                <span class="error-msg">{{ notification.sectorError }}</span>
              </div>

              <!-- <div v-show="notification.target === 'all'"
                :class="{'data-field':true, 'has-error':!!notification.brandErrorMsg}">
                <div class="label">{{ $t('consumer.list.brands') }}:</div>
                <select v-model="notification.brand">
                  <option v-for="brand in brands" :value="brand.id">{{ brand.name }}</option>
                </select>
                <span class="error-msg">{{ notification.brandErrorMsg }}</span>
              </div> -->

              <label v-if="false">
                <input type="checkbox" v-model='notification.isPushNotif' />
                {{ $t('consumer.list.pushNotif') }}
              </label>
              <label v-if="false">
                <input type="checkbox" v-model='notification.isSendEmail' />
                {{ $t('consumer.list.email') }}
              </label>

              <div :class="{'data-field':true, 'has-error':!!notification.titleError}">
                <div class="label">{{ $t('consumer.list.title') }}:</div>
                <input type="text" v-model="notification.title" class="input" />
                <span class="error-msg">{{ notification.titleError }}</span>
              </div>

              <div class="textarea-box">
                <textarea v-model='notification.message' rows="5"
                  :class="{'exceed':notification.charExceed}"
                  v-on:keydown="charCountUpdate" v-on:keyup="charCountUpdate"
                  :placeholder="$t('consumer.list.message')" ref="notifMsg"></textarea>
                <i class="far fa-smile fa-lg emoji-trigger" @click.stop
                  @click="notification.showEmoji = !notification.showEmoji"></i>
                <!-- <span :class="{'char-count':true, 'exceed':notification.charExceed}">
                  {{ $t('consumer.list.charLeft', {count: notification.charCount}) }}
                </span> -->
              </div>

              <div :class="{'data-field':true, 'has-error':!!notification.fileError}" v-if="false">
                <div class="label">{{ $t('consumer.list.img') }}:</div>
                <div class="file-box">
                  <input type="file" name="image" accept="image/*" v-if="notification.fileReady"
                    @change="setImage" class="input-file" ref="fileInput" />
                  <i class="fas fa-times fa-lg" @click="cleanFileInput"
                    v-if="!!notification.file"></i>
                </div>
                <span class="error-msg">{{ notification.fileError }}</span>
              </div>

              <label class="announcement-check" v-show="notification.target === 'all'">
                <input type="checkbox" v-model='notification.isAnnouncement' />
                Send as announcement
              </label>

              <div @click="checkFileUpload"
                :class="{'button cta warning block':true, 'disabled':disableNotifButton}">
                {{ $t('consumer.list.send') }}
              </div>
              <a class="cancel-notif" @click="closeNotifForm">{{ $t('consumer.list.cancel') }}</a>
            </div>

            <div v-show="!!notification.errorMsg" class="error">
              <i class="far fa-frown fa-5x"></i>
              <p>{{ $t('consumer.list.errorMsg') }}</p>
              <code>{{ notification.errorMsg }}</code>
              <div class="button cta block small error"
                @click="closeNotifForm">{{ $t('consumer.list.close') }}</div>
            </div>

            <div v-show="notification.success" class="success-box">
              <i class="far fa-check-circle fa-5x"></i>
              <p>{{ $t('consumer.list.sendNotifSuccess') }}</p>
              <div class="button cta block small success"
                @click="closeNotifForm">{{ $t('consumer.list.close') }}</div>
            </div>

            <transition name="slide-left">
              <div @click.stop v-show="notification.showEmoji" class="emoji-box">
              <picker :style="emojiStyle" :exclude="['recent']" @select="addEmoji" />
              </div>
            </transition>

            <transition name="pop">
              <div class="loader" v-show="notification.loading">
                <div>
                  <i class="fas fa-spinner fa-spin"></i>
                  <span>{{ $t('consumer.list.sendingNotif') }}</span>
                </div>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Picker } from 'emoji-mart-vue'
import ApiNotif from '@/modules/api/provider/notifications'

export default {
  name: 'notification-modal',
  props: ['isList', 'provId', 'removeAllActiveUserOption', 'hideTargetOption', 'showGeofenceOption', 'showBySector', 'broadcastOnly'],
  data () {
    return {
      notification: {
        showForm: false,
        target: 'all',
        targetMessage: '',
        geofence: {
          show: false,
          type: '',
          brand: '',
          id: '',
          loading: false,
          list: [],
          error: {
            type: '',
            brand: '',
            id: '',
          },
        },
        isPushNotif: true,
        isSendEmail: false,
        brand: '',
        brandErrorMsg: '',
        title: '',
        titleError: '',
        message: '',
        charCount: 180,
        charExceed: false,
        showEmoji: false,
        file: '',
        fileReady: true,
        uploadedUrl: '',
        fileError: '',
        isAnnouncement: true,
        loading: false,
        errorMsg: '',
        success: false,
        sector: 'group1',
        sectorError: ''
      },
      selected: []
    }
  },
  components: {Picker},
  computed: {
    // provId () { return this.$route.params.id },
    disableNotifButton () {
      let zeroTarget = this.notification.target === 'selected' && !this.selected.length
      this.notification.targetMessage = zeroTarget ? this.$t('consumer.list.zeroSelected') : ''

      let geofenceCheck = true
      if (this.notification.target === 'geofence' && (!this.notification.geofence.type ||
        !this.notification.geofence.id || (this.notification.geofence.type === 'serviceArea' && !this.notification.geofence.brand))
      ) {
        geofenceCheck = false
      }

      return zeroTarget || this.notification.message === '' || this.notification.charExceed ||
        this.notification.fileError !== '' || (!this.notification.isPushNotif && !this.notification.isSendEmail) || !geofenceCheck
    },
    emojiStyle () { return {'width': '100%', 'height': '100%'} },
    brands () { return this.$store.state.brands.list }
  },
  methods: {
    showNotifForm () {
      if (this.provId.length > 0) {
        this.notification.target = 'selected'
        this.notification.geofence.show = false
      }
      this.notification.showForm = true
    },
    closeNotifForm () {
      if (this.notification.showEmoji) {
        this.closeEmoji()
        return
      }

      if (this.notification.loading) { return }
      this.notification.showForm = false
      this.notification.brandErrorMsg = ''
      this.notification.errorMsg = ''
      this.notification.success = false
    },
    closeEmoji () {
      if (this.notification.showEmoji) {
        this.notification.showEmoji = false
      }
    },
    charCountUpdate () {
      this.notification.charCount = 180 - (this.notification.message.length)
    },
    addEmoji (emoji) {
      this.notification.showEmoji = false

      let textarea = this.$refs.notifMsg
      let cursorPosition = textarea.selectionEnd
      let start = this.notification.message.substring(0, textarea.selectionStart)
      let end = this.notification.message.substring(textarea.selectionStart)
      let text = start + emoji.native + end
      this.notification.message = text
      textarea.focus()
      let self = this
      this.$nextTick(() => {
        textarea.selectionEnd = cursorPosition + emoji.native.length
        self.charCountUpdate()
      })
    },
    cleanFileInput () {
      this.notification.file = ''
      this.notification.fileError = ''
      this.notification.fileReady = false
      this.$nextTick(() => {
      	this.notification.fileReady = true
      })
    },
    checkFileUpload () {
      let self = this
      if (this.notification.file) {

        let fd = new FormData()
        fd.append('pic', self.notification.file, 'consumer-notif.png')

        self.$http.post(CONFIG.mediaHost + '/api/upload', fd, {
          header: { 'Content-Type': 'multipart/form-data' }
        }).then(function (res) {
          if (res.body.success) {
            self.notification.uploadedUrl = res.body.data.url
            self.submitNotif()
          }
        })
        return
      }

      self.submitNotif()
    },
    submitNotif () {
      let self = this
      let selectedId = self.notification.target === 'all' ? null : self.selected
      let data = {
        title: self.notification.title,
        message: self.notification.message,
        // image: self.notification.uploadedUrl,
        contactID: selectedId,
        announcement: false
      }

      self.notification.brandErrorMsg = ''
      if (self.notification.target === 'all') {
        // if (!self.notification.brand) {
        //   self.notification.brandErrorMsg = self.$t('consumer.list.emptyBrand')
        //   return
        // }
        data.announcement = self.notification.isAnnouncement
        data.brandId = self.notification.brand
      }

      if (self.notification.target === 'geofence') {
        data.geofenceId = self.notification.geofence.id
        delete data.contactID
      }

      let sectorId = [1, 2, 3, 4, 5, 6]
      if (self.notification.target === 'sector') {
        if (self.notification.sector === 'group2') sectorId = [7, 8, 9, 10, 11]
        if (self.notification.sector === 'group3') sectorId = [12, 13, 14, 15, 16, 17, 18]
        if (self.notification.sector === 'group4') sectorId = [19, 20, 21, 22, 23]
        data.sectorId = sectorId
        delete data.contactID
      }

      self.notification.loading = true
      if (self.notification.isAnnouncement && !self.broadcastOnly) {
        let announcement = {
          title: self.notification.title,
          message: self.notification.message,
        }
        ApiNotif.sendAnnouncement(self, announcement, function (res) {
          self.notification.isAnnouncement = false
        })
      }
      ApiNotif.send(self, data, function (res) {
        self.notification.loading = false
        self.notification.success = true
        self.notification.title = ''
        self.notification.message = ''
        self.notification.uploadedUrl = ''
        self.cleanFileInput()
      })
    },
    targetUpdate () {
      this.notification.geofence.show = this.notification.target === 'geofence'
    },
    updateGeofenceList () {
      let self = this
      if (self.notification.geofence.loading) { return }

      if (self.notification.geofence.type === 'serviceArea' && !self.notification.geofence.brand) {
        return
      }

      self.notification.geofence.loading = true
      self.notification.geofence.list = []

      let request = {
        token: self.$store.state.session.sessionToken,
        status: 'active',
        pageNum: 1,
        pageSize: 999,
        order: 'priority'
      }
      self.notification.geofence.id = ''
      if (self.notification.geofence.type === 'serviceArea') {
        request.brandId = self.notification.geofence.brand
        self.$sdk.get('/servicearea', request, r => {
          self.notification.geofence.loading = false
          if (r.error) {
            console.log('ERROR:', r.error.message)
            return
          }

          r.list.forEach(geofence => {
            self.notification.geofence.list.push({
              id: geofence.id,
              name: geofence.name
            })
          })
        }, '2.0')
      } else {
        request.type = self.notification.geofence.type
        self.$sdk.get('/geofences/search', request, r => {
          self.notification.geofence.loading = false
          if (r.error) {
            console.log('ERROR:', r.error.message)
            return
          }

          r.list.forEach(geofence => {
            self.notification.geofence.list.push({
              id: geofence.id,
              name: geofence.name
            })
          })
        })
      }
    }
  },
  watch: {
    provId: function (value) {
      this.selected = this.isList ? value : [value]
    }
  },
  mounted () {
    if (!this.isList) {
      this.notification.target = 'selected'
      this.selected = [this.$route.params.id]
    }
    if (this.removeAllActiveUserOption) {
      this.notification.target = 'selected'
    }
  }
}
</script>

<style lang="scss" scoped>
.data-field{
  position: relative;
  margin-bottom: 20px;
  &.reduce-margin{
    margin-bottom: 12px;
  }
  .label{
    color: #888;
    font-weight: 600;
    font-size: 12px;
    line-height: 130%;
    margin-bottom: 3px;

    &.has-error{ color: #f20d0d; }
  }
  .input{
    margin: 5px 0 0;
    color: #333;
    line-height: inherit;
    transition: all .35s ease;

    &.has-error{ border-color: #f20d0d; }
    &:disabled{ background: #eee; }
  }
  .error-msg{
    font-size: 11px;
    line-height: 1.6;
    color: #f20d0d;
    font-style: italic;
    display: block;
  }
}

.op--modal-container {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0,0,0,0.35);
  opacity: 1;
  -webkit-transition: all 0.2s ease-in;
  -moz-transition: all 0.2s ease-in;
  -o-transition: all 0.2s ease-in;
  transition: all 0.2s ease-in;

  &.hide {
    top: -100%;
    opacity: 0;
  }
}
.op--modal {
  display: table;
  width: 100%;
  height: 100%;
}
.op--modal-content {
  display: table-cell;
  vertical-align: middle;
}

.notification-form{
  background-color: #fff;
  max-width: 400px;
  margin: 10px auto;
  border-radius: 3px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.3);

  .heading{
    background: #333;
    color: #fff;
    padding: 10px;
    font-size: 18px;
    text-align: center;
  }

  .nf-content{
    padding: 20px;
    position: relative;

    .label{
      font-size: 13px;
      color: #555;
    }
    label{
      display: block;
      font-size: 14px;
      color: #555;
      margin-bottom: 2px;
      cursor: pointer;

      input{
        display: inline-block;
        vertical-align: middle;
        margin-right: 5px;
      }
    }
    .textarea-box{
      position: relative;
      margin-bottom: 15px;
      padding-bottom: 20px;

      .emoji-trigger{
        position: absolute;
        bottom: -3px;
        left: 0;
        color: #aaa;
        cursor: pointer;
      }
    }
    textarea{
      margin: 0;
      padding: 10px;
      width: 100%;
      resize: none;
      background: #fdfdfd;
      font-size: 14px;
      outline: none;
      color: #333;
      border-color: #ddd;
      box-shadow: 1px 1px 3px rgba(0,0,0, .05) inset;
      transition: all .3s ease;

      &.exceed{
        border-color: #d61613;
        background: #fff0f0;
      }
    }
    .char-count{
      font-size: 12px;
      color: #777;
      display: block;
      text-align: right;
      line-height: 1;
      margin-top: 5px;

      &.exceed{ color:#f00; }
    }
    .cancel-notif{
      display: block;
      font-size: 13px;
      margin: 10px 0 0;
      text-align: center;
      cursor: pointer;
      color: #bbb;
      transition: all .5s ease;
      &:hover{ color:#333; }
    }
    .file-box{
      position: relative;

      input{
        padding: 5px 25px 5px 5px;
        margin:0;
        font-size: 14px;
      }
      i{
        position: absolute;
        z-index: 2;
        top: 50%;
        right: 5px;
        transform: translateY(-50%);
        color: #fd4a38;
        cursor: pointer;
      }
    }
  }

  .error{
    text-align: center;
    i{ color:#fd4a38; }
    p{ margin: 5px 0 20px; }
    code{
      border:2px solid #fd4a38;
      padding: 10px;
      width: 100%;
      display: block;
      font-size: 14px;
      background: #ffeeec;
      border-radius: 3px;
      margin-bottom: 30px;
    }
  }

  .success-box{
    text-align: center;
    i{ color: #26d97a; }
  }

  .loader{
    position: absolute;
    top:0;
    left: 0;
    z-index: 2;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.3);

    div{
      position: absolute;
      top:50%;
      left: 0;
      height: 50px;
      width: 100%;
      transform: translateY(-50%);
      text-align: center;

      i{ color: #45e7f9; }
      span{
        color: #fff;
        font-size: 21px;
        font-weight: 600;
        margin-left: 5px;
        text-shadow: 1px 1px 1px rgba(0,0,0, .4);
      }
    }
  }
}

.select-box{
  position: relative;

  .select-loader{
    position: absolute;
    top: 50%;
    left: 50%;
    font-size: 13px;
    transform: translate(-50%, -50%);
    z-index: 2;
    color: #a2a6aa;
    
    i{
      vertical-align: -1px;
      margin-right: 3px;
    };
  }
  select{
    position: relative;
    z-index: 1;
  }
}

.emoji-box{
  position: absolute;
  top: 0;
  left: 100%;
  z-index: 2;
  width: 100%;
  height: 100%;
}

.announcement-check{
  margin-bottom: 5px!important;
  padding-left: 2px;
}
input[type="checkbox"]{
  width: auto;
  margin-top: 0;
}

.disabled-opt{
  font-style: italic;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/App/NotificationModal.vue